import ErrorPage from "../Components/App/ErrorPage";

function Error() {
    return (
        <ErrorPage />
    );
}

export default Error;